import deepMerge from 'lodash.merge';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import React from 'react';

import { getThemeProps } from '@src/config/theme';

export default function LocalizedThemeProvider({ children }) {
  const themeProps = getThemeProps();
  const theme = createTheme(
    deepMerge(
      {
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: 'math-auto',
              },
            },
          },
        },
      },
      themeProps,
    ),
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
